<script>
  import { createEventDispatcher } from 'svelte';

  export let dimension;
  export let verified = false;
  export let extraStyle = '';
  export let extraStyleIcon = '';
  export let clickable = false;

  const dispatch = createEventDispatcher();
  const dispatchIfClickable = function (e) {
    dispatch('areaClicked', { event: e });
  };
</script>

<style style="text/scss" lang="scss">
</style>

<span
  on:click|preventDefault|stopPropagation={dispatchIfClickable}
  style="display: inline-flex; flex-direction: row; gap: {dimension / 2}px; {clickable
    ? 'cursor: pointer;'
    : ''} {extraStyle} ">
  <slot name="account-name" />
  {#if verified}
    <span style="display: inline-flex; justify-content: center; align-items: center; {extraStyleIcon}">
      <svg width={dimension} height={dimension} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.5 12C9.81371 12 12.5 9.31371 12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 9.31371 3.18629 12 6.5 12Z"
          fill="#47B3FF" />
        <path
          d="M3.875 5.88971L5.69231 7.875L9.125 4.125"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>
  {/if}
</span>
